// Beast icon component - displays species-specific icons
const BEAST_ICONS = {
  atlas_bear: '/bear.png',
  barbary_lion: '/lion.png',
  anatolian_leopard: '/leopard.png',
  eurasian_wolf: '/wolf.png',
  barbary_macaque: '/macaque.png',
  nile_crocodile: '/crocodile.png',
};

export default function BeastIcon({ size = 24, className = "", species = null }) {
  // Use species-specific icon if provided, otherwise use the vivarium default icon
  const iconSrc = species && BEAST_ICONS[species] ? BEAST_ICONS[species] : '/vivarium-icon.png';
  
  return (
    <img 
      src={iconSrc} 
      alt="Beast" 
      width={size} 
      height={size}
      className={`inline-block ${className}`}
      style={{ width: size, height: size, objectFit: 'cover', borderRadius: '4px' }}
    />
  );
}

